import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Loader2 } from 'lucide-react';

// target: { activity } para una actividad o { overall: true } para el turnaround completo
export function DelayCauseDialog({ target, causes, onClose, onSubmit }) {
    const [cause, setCause] = useState('');
    const [note, setNote] = useState('');
    const [saving, setSaving] = useState(false);
    useEffect(() => { setCause(''); setNote(''); }, [target]);

    const submit = async () => {
        setSaving(true);
        try { await onSubmit({ cause, note, activity_key: target?.activity?.key }); } finally { setSaving(false); }
    };

    return (
        <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
            <DialogContent data-testid="ta-delay-dialog">
                <DialogHeader>
                    <DialogTitle>Causa de demora</DialogTitle>
                    <DialogDescription>{target?.activity ? `Actividad: ${target.activity.name} (${target.activity.area})` : 'Turnaround completo: excedió el tiempo estándar'}</DialogDescription>
                </DialogHeader>
                <div className="space-y-3">
                    <div className="space-y-1.5">
                        <Label>Causa</Label>
                        <Select value={cause} onValueChange={setCause}>
                            <SelectTrigger data-testid="ta-delay-cause-select"><SelectValue placeholder="Selecciona una causa" /></SelectTrigger>
                            <SelectContent>
                                {(causes || []).map(c => <SelectItem key={c} value={c} data-testid={`ta-delay-cause-${c}`}>{c}</SelectItem>)}
                            </SelectContent>
                        </Select>
                    </div>
                    <div className="space-y-1.5">
                        <Label>Detalle (opcional)</Label>
                        <Textarea value={note} onChange={e => setNote(e.target.value)} rows={2} data-testid="ta-delay-note" />
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={onClose}>Cancelar</Button>
                    <Button onClick={submit} disabled={saving || !cause} data-testid="ta-delay-submit">
                        {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Registrar causa
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
